
import mixins from "vue-typed-mixins";

import WebStorage from '@/common/WebStorage';
import { nodeHelpers } from '@/components/mixins/nodeHelpers';
import { workflowHelpers } from '@/components/mixins/workflowHelpers';
import { titleChange } from '@/components/mixins/titleChange';

import { formatUtcDate } from '@/utils/date';
import ModalButtonSuccess from '@/components/ModalButtonSuccess.vue';
import ModalButtonCancel from '@/components/ModalButtonCancel.vue';
import WorkflowNameShort from "@/components/WorkflowNameShort.vue";
import ReadOnly from "@/components/MainHeader/ExecutionDetails/ReadOnly.vue";
import AlertNotificationModal from '@/components/AlertNotificationModal.vue';
import { DUPLICATE_MODAL_KEY } from '@/constants';

import ScrollInfinite from '@/components/ScrollInfinite.vue';


export default mixins(
	nodeHelpers,
	workflowHelpers,
	titleChange,
).extend({
	name: "VersionHistoryDetails",
	components: {
		WorkflowNameShort,
		ReadOnly,
		ModalButtonSuccess,
		ModalButtonCancel,
		ScrollInfinite,
		AlertNotificationModal,
	},
	data() {
		return {
			showSelectVersion: false,
			historyVersionData: [],
			page: 1,
			scrollInfiniteContinue: true,
			showAlert: false,
		};
	},
	computed: {
		alertNotificationDescription() {
			return this.$locale.baseText('VersionHistoryDetails.confirmMessage.workflowRestore.message', {
				interpolate: { workflowName: this.workflowName },
			});
		},
		workflowVersionData() {
			return this.$store.getters.getWorkflowVersionData;
		},
		versionInfo() {
			return this.$store.getters.versionInfo;
		},
		workspace() {
			return this.$store.getters.workspace;
		},
		workflowName() {
			return this.$store.getters.workflowName;
		},
	},
	methods: {
		hideSelectVersion() {
			this.showSelectVersion = false;
		},
		onFocus() {
			this.isFocused = !this.isFocused;
		},
		formatDate(date) {
			return formatUtcDate(date, 'DD/MM/YYYY [às] HH[h]:mm[min]');
		},
		async restoreVersion() {
			try {
				let	data = await this.restApi().getWorkflow(this.workspace.id, this.workflowVersionData.workflowId);

				delete data.modificadoEmDataHora;
				delete data.modificadoPorUsuario;
				delete data.triggerError;
				delete data.tenant;

				data.workflowData.nodes = this.workflowVersionData.workflowData.nodes;
				data.projetoId = data.projeto.id;
				delete data.projeto;
				data.workflowData.connections = this.workflowVersionData.workflowData.connections;

				const workflowData = await this.restApi().updateWorkflow(this.workspace.id, data.id ,data);

				this.$store.commit('activeAlert', {
					message: this.$locale.baseText('VersionHistoryDetails.restoreSuccess', { interpolate: {savedWorkflowName: workflowData.nome} }),
				});

				this.showAlert = false;
				this.openWorkflow(workflowData.id);
			} catch(e) {
				console.error(e);
				this.$store.commit('activeAlert', {
					message: e?.notifications[0] || e,
					status: 'error'
				});
			}
		},

		async openWorkflow(workflowId: string) {
			this.$titleSet(this.workflowName, "IDLE");
			// Change to other workflow
			this.$router.push({
				name: "NodeViewExisting",
				params: { name: workflowId },
			});
		},

	},
	watch: {
		
	},
	mounted() {
	},
});
